{
  "All Invoices": "All Invoices — {{name}}",
  "View Invoice": "View invoice",
  "invoices_one": "{{count}} invoice",
  "invoices_other": "{{count}} invoices",
  "You currently don't have any invoices here": "You currently don't have any invoices here",
  "Back": "Back"
}
